module.exports = __webpack_public_path__ + "img/slideVerify_12.085d9dfb.png";